<div class="container-fluid" *ngIf="!isScletonLoaderVisible">
  <div class="row">
    <div class="col-12" style="padding: 0px">
      <div class="stats-wrapper">
        <div class="mb-50">
          <button
            class="filter-button"
            [class.active]="filter == 0"
            mat-button
            (click)="onSelectFilter(0)"
          >
            Total
          </button>
          <button
            class="filter-button"
            [class.active]="filter == 1"
            mat-button
            (click)="onSelectFilter(1)"
          >
            Year
          </button>
          <button
            class="filter-button"
            [class.active]="filter == 2"
            mat-button
            (click)="onSelectFilter(2)"
          >
            30 Days
          </button>
          <button
            class="filter-button"
            [class.active]="filter == 3"
            mat-button
            (click)="onSelectFilter(3)"
          >
            7 Days
          </button>
        </div>
        <div>
          <div
            class="stat"
            (click)="selectGraphName('Revenue')"
            [ngClass]="{ active: selectedGraphName == 'Revenue' }"
          >
            <p class="p-0">
              <span class="stat-title">Expenses</span>
              <span class="stat-title"> | BAM</span>
            </p>
            <div class="stats-box">
              <div class="stat-number">{{ revenue | number : "1.2-2" }}</div>
              <div>
                <ngx-charts-line-chart
                  [scheme]="colorScheme"
                  [legend]="false"
                  [showXAxisLabel]="false"
                  [showYAxisLabel]="false"
                  [tooltipDisabled]="true"
                  [xAxis]="false"
                  [view]="[100, 30]"
                  [yAxis]="false"
                  [timeline]="false"
                  [results]="revenueGraphData"
                >
                </ngx-charts-line-chart>
              </div>
            </div>
          </div>

          <div
            [ngClass]="{ active: selectedGraphName == 'Scans' }"
            class="stat"
            (click)="selectGraphName('Scans')"
          >
            <p>
              <span class="stat-title"
                ><svg
                  width="19"
                  height="22"
                  viewBox="0
                    0
                    19 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.16602 20H2.16602C1.61602 20 1.14502 19.8043
                      0.753016 19.413C0.361682 19.021 0.166016 18.55 0.166016
                      18V4C0.166016 3.45 0.361682 2.979 0.753016 2.587C1.14502
                      2.19567 1.61602 2 2.16602
                      2H6.16602V4H2.16602V18H6.16602V20ZM8.16602
                      22V0H10.166V22H8.16602ZM16.166 4V2C16.716 2 17.187 2.19567
                      17.579 2.587C17.9703 2.979 18.166 3.45 18.166
                      4H16.166ZM16.166 12V10H18.166V12H16.166ZM16.166
                      20V18H18.166C18.166 18.55 17.9703 19.021 17.579
                      19.413C17.187 19.8043 16.716 20 16.166 20ZM16.166
                      8V6H18.166V8H16.166ZM16.166 16V14H18.166V16H16.166ZM12.166
                      20V18H14.166V20H12.166ZM12.166 4V2H14.166V4H12.166Z"
                    fill="#CCCCCC"
                  />
                </svg>
                Scans</span
              >
            </p>
            <div class="stats-box">
              <div class="stat-number">{{ scans }}</div>
              <div>
                <ngx-charts-line-chart
                  [legend]="false"
                  [showXAxisLabel]="false"
                  [showYAxisLabel]="false"
                  [xAxis]="false"
                  [view]="[100, 30]"
                  [yAxis]="false"
                  [timeline]="false"
                  [results]="scansGraphData"
                >
                </ngx-charts-line-chart>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="p-30">
          <h3 class="charts-title">
            {{ getSelectedGraphName(selectedGraphName) }}
          </h3>
          <div *ngIf="isGraphTextString()" class="graph-text">{{ getGraphBelowTextName() }}</div>
          <div *ngIf="!isGraphTextString()" class="graph-text" style="display: flex; align-items: center;">In the past 30 days, Scans have <span style="color: #FECE23; margin-left: 5px;"> increased by {{ getGraphBelowTextName() }}%</span>
            <img style="margin-left: 4px;" src="assets/icons/expand_less.svg" alt="Your Icon" />
          </div>
          


          <div class="chart-box">
            <ngx-charts-line-chart
              [scheme]="colorScheme"
              [legend]="false"
              [showXAxisLabel]="false"
              [showYAxisLabel]="false"
              [tooltipDisabled]="true"
              [xAxis]="true"
              [yAxis]="true"
              [timeline]="false"
              [results]="multi"
            >
            </ngx-charts-line-chart>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isScletonLoaderVisible">
  <div style="display: flex; margin-left: 40px; margin-top: 36px">
    <div
      style="width: 79px; height: 56px; margin-right: 16px"
      class="placeholder-shimmer"
    ></div>
    <div
      style="width: 79px; height: 56px; margin-right: 16px"
      class="placeholder-shimmer"
    ></div>
    <div
      style="width: 79px; height: 56px; margin-right: 16px"
      class="placeholder-shimmer"
    ></div>
    <div
      style="width: 79px; height: 56px"
      class="placeholder-shimmer"
      class="placeholder-shimmer"
    ></div>
  </div>
  <div style="display: flex; margin-left: 40px; margin-top: 40px">
    <div
      style="width: 346px; height: 228px; margin-right: 16px"
      class="placeholder-shimmer"
    ></div>
    <div
      style="width: 346px; height: 228px; margin-right: 16px"
      class="placeholder-shimmer"
    ></div>
    <div style="width: 346px; height: 228px" class="placeholder-shimmer"></div>
  </div>
  <div
    style="
      display: flex;
      flex-direction: column;
      margin-left: 40px;
      margin-top: 80px;
    "
  >
    <div
      style="width: 146px; height: 40px; margin-bottom: 10px"
      class="placeholder-shimmer"
    ></div>
    <div style="width: 146px; height: 19px" class="placeholder-shimmer"></div>
  </div>
  <div
    style="width: 1075px; height: 250px; margin: 40px 0 0 40px; padding: 0 40px"
    class="placeholder-shimmer"
  ></div>
</div>
